(function (angular) {
	'use strict';

	angular
		.module('investorOwnedModule')
		.directive('investorOwnedSlider', [
			'$timeout',
			'$window',
			'BREAKPOINTS',
			'RevealService',
			'STATIC_BASE_PATH',
			investorOwnedSliderFunction
		]);

	function investorOwnedSliderFunction($timeout, $window, BREAKPOINTS, RevealService, STATIC_BASE_PATH) {
		return {
			restrict: 'E',
			templateUrl: STATIC_BASE_PATH + '/' + 'static/html/ria/investor-owned/investor-owned-slider.html',
			replace: true,
			scope: {
				ctaUrl: '@',
				fundriseImg: '@',
				fundriseImgMobile: '@',
				fundriseTitle: '@',
				fundriseContent: '@',
				textAlignment: '@',
				mixpanelContainer: '@',
				wallstreetImg: '@',
				wallstreetImgMobile: '@',
				wallstreetTitle: '@',
				wallstreetContent: '@'
			},
			link: function ($scope, $elem, $attrs) {
				$scope.isMobileViewport = $window.innerWidth < BREAKPOINTS.MD_START;
				$scope.showFundriseSlide = false;
				$scope.initialTransition = false;
				
				if (!$scope.isMobileViewport){
					$scope.offset = $elem[0].getBoundingClientRect().left;
					$scope.elementWidth = $elem[0].getBoundingClientRect().width;
					$scope.iconWidth = 40;
					$scope.overlayWidth = 40;
				}
				
				$scope.learnMoreCtaClicked = function(){
					if ($scope.isMobileViewport){
						$scope.showFundriseSlide = true;
						if($window.mixpanel) {
							$window.mixpanel.track('Investor Owned Mobile Learn More CTA Clicked', {
								Section: $scope.mixpanelContainer
							});
						}
					} else {
						var overlayWidth = parseInt($scope.elementWidth) - (parseInt($scope.iconWidth) / 2);
	
						transitionAnimation(overlayWidth);
						$scope.$broadcast('investorOwner:fullyExpandIcon');
					}
				};
				
				$scope.toggleView = function(){
					$scope.showFundriseSlide = !$scope.showFundriseSlide;
					if($window.mixpanel) {
						$window.mixpanel.track('Investor Owned Mobile Toggle Clicked', {
							Section: $scope.mixpanelContainer
						});
					}
				};
				
				function transitionAnimation(overlayWidth){
					$timeout(function(){
						$scope.$apply(function(){
							$scope.transition = '1s all ease';
							$scope.overlayWidth = overlayWidth;
							$scope.initialTransition = true;
						});
					});
					
					$timeout(function(){
						$scope.transition = 'none';
					}, 1000);
				}

				function assessInViewport(){
					var isInViewport = RevealService.isMiddleOfElementInViewport($elem[0]);
					
					if (isInViewport){
						angular.element($window).off('load scroll', assessInViewport);
						initialSlideOut();
					}
				}
				
				function initialSlideOut(){
					var overlayWidth = 200 + (parseInt($scope.iconWidth) / 2);
					transitionAnimation(overlayWidth);
				}

				angular.element($window).on('load scroll', assessInViewport);
			}
		};
	}
})(window.angular);